const API_BASE = '';

async function fetchAPI<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error?.message || body.error || `HTTP ${res.status}`);
  }

  return res.json();
}

export interface UserProfile {
  user: {
    id: string;
    email: string;
    name: string | null;
    onboardingStep: string | null;
    createdAt: string;
  } | null;
  onboardingStep: string;
  instance: {
    id: string;
    name: string;
    status: string;
    runtime: string;
    tier: string;
    url: string;
    createdAt: string;
  } | null;
}

export interface DeployResult {
  instance: {
    id: string;
    name: string;
    status: string;
    url: string;
    runtime: string;
    tier: string;
  };
  apiKey: string;
  proxyUrl: string;
}

export interface DashboardData {
  totalRequests: number;
  totalCostUsd: number;
  totalSavedUsd: number;
  modelMix: { haiku: number; sonnet: number; opus: number };
  cacheHitRate: number;
  dailyTrend: { date: string; requests: number; cost: number }[];
  budgetLimitUsd: number;
}

export interface InstanceStatus {
  status: string;
  instance: {
    id: string;
    name: string;
    status: string;
    runtime: string;
    tier: string;
    url: string;
  } | null;
}

export const api = {
  getMe: () => fetchAPI<UserProfile>('/app/me'),

  deploy: (name: string, soulTemplate: string) =>
    fetchAPI<DeployResult>('/app/deploy', {
      method: 'POST',
      body: JSON.stringify({ name, soulTemplate }),
    }),

  getInstanceStatus: () => fetchAPI<InstanceStatus>('/app/instance/status'),

  getDashboard: () => fetchAPI<DashboardData>('/app/dashboard'),

  rotateKey: () =>
    fetchAPI<{ apiKey: string }>('/app/rotate-key', { method: 'POST' }),
};
